import { packArtwork, unpackArtwork } from "./studioAssets";

// Local recovery for unsaved work. IndexedDB when available (asynchronous,
// no serialization on the editing path); otherwise localStorage written off
// the commit path. Records: { doc, revision, dirty, pending, savedAt }.
// Legacy drafts under "demi-menu-studio-v1:<menu>" stay readable and are
// never deleted here.
const LEGACY = (menuKey) => `demi-menu-studio-v1:${menuKey}`;
let dbPromise;
const request = (req) => new Promise((resolve, reject) => { req.onsuccess = () => resolve(req.result); req.onerror = () => reject(req.error); });
function database() {
  if (typeof indexedDB === "undefined") return null;
  if (!dbPromise) {
    const open = indexedDB.open("demi-menu-studio", 1);
    open.onupgradeneeded = () => open.result.createObjectStore("drafts");
    dbPromise = request(open).then((db) => ({
      get: (key) => request(db.transaction("drafts").objectStore("drafts").get(key)),
      put: (value, key) => new Promise((resolve, reject) => {
        const tx = db.transaction("drafts", "readwrite");
        tx.objectStore("drafts").put(value, key);
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
      }),
    })).catch(() => null);
  }
  return dbPromise;
}

export async function readRecovery(menuKey) {
  const db = await database();
  let record = null;
  if (db) {
    try { record = await db.get(menuKey); } catch (_) { record = null; }
  }
  let legacy = null;
  try {
    legacy = JSON.parse(localStorage.getItem(LEGACY(menuKey)));
  } catch (_) {
    legacy = null;
  }
  // An older editor tab may still write the legacy key; prefer whichever
  // record is based on the newer cloud revision.
  if (legacy && (!record || (Number(legacy.revision) || 0) > (Number(record.revision) || 0))) record = legacy;
  if (record?.doc) record = { ...record, doc: unpackArtwork(record.doc) };
  return record || null;
}

// Resolves once the record is durable; callers show "Recovery saved" only then.
export async function writeRecovery(menuKey, record) {
  const db = await database();
  if (db) {
    await db.put({ ...record, savedAt: new Date().toISOString() }, menuKey);
    return true;
  }
  await new Promise((resolve) => setTimeout(resolve, 0));
  localStorage.setItem(LEGACY(menuKey), JSON.stringify({ ...record, doc: packArtwork(record.doc), savedAt: new Date().toISOString() }));
  return true;
}

export async function writeConflictBackup(menuKey, doc) {
  try {
    const db = await database();
    if (db) await db.put({ doc, conflict: true, savedAt: new Date().toISOString() }, `${menuKey}:conflict-backup`);
    else localStorage.setItem(`${LEGACY(menuKey)}:conflict-backup`, JSON.stringify(packArtwork(doc)));
  } catch (_) { /* best effort; the draft is also exportable */ }
}
